<template>
  <el-button
    type="primary"
    circle
    class="flex md:hidden"
    @click="useUIStore().burgerMenu = true"
  >
    <icon-burger
      class="w-auto"
    />
  </el-button>
</template>
